<template readonly="true">
  <div>
    <v-overlay v-if="loading">
      <Loader class="loading-page" />
    </v-overlay>
    <v-card
      v-if="!loading"
      color="white "
      style="margin: 10px; border-radius: 20px; padding: 0px !important"
      class="pa-3 mb-8"
    >
      <v-row class="mx-auto">
        <v-col
          style="
            background: radial-gradient(
              circle,
              #b22af0 0%,
              #6db2e3 100%
            ) !important;
            border-radius: 20px 20px 20px 20px;
          "
          class="text"
          cols="12"
          md="3"
        >
          <v-icon class="ma-4" color="black" @click="$router.go(-1)"
            >fas fa-arrow-left</v-icon
          >
          <div class="text-center black--text">
            <div
              ref="profileImage"
              class="text"
              style="text-transform: capitalize; margin-top: 16px !important"
            >
              <v-avatar style="color: white" outline size="130">
                <!-- <div > -->
                <p class="hidden-sm-and-down hidden-md-and-up">{{ avatar }}</p>
                <v-img v-if="hasAvatar" :src="avatarPic"></v-img>

                <!-- </div> -->
                <svg
                  v-else
                  viewBox="0 0 32 32"
                  xmlns="http://www.w3.org/2000/svg"
                  style="fill: currentcolor"
                  aria-hidden="true"
                  role="presentation"
                  focusable="false"
                >
                  <path
                    d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                  ></path>
                </svg>
              </v-avatar>
            </div>

            <h1 style="color: black; text-transform: capitalize">
              {{ firstName }}
            </h1>
            <p class="hidden-sm-and-down hidden-md-and-up">{{ strappDate }}</p>
            <p class="hidden-sm-and-down hidden-md-and-up">{{ isVerified }}</p>
            <h5
              class="text"
              style="
                margin-left: 10px;
                font-weight: normal !important;
                color: black;
              "
              v-if="startDate != null"
            >
              Active since {{ startDate }}
            </h5>
            <v-row
              align="center"
              justify="center"
              v-if="verified === true"
              class="mt-6 text-center text"
              style="align-items: center; margin-top: 0px !important"
            >
              <svg
                :style="
                  $vuetify.breakpoint.xsOnly
                    ? 'height: 10px; width: 10px; margin-right 5px !important;'
                    : '' && $vuetify.breakpoint.smAndDown
                    ? 'height: 30px; width: 30px; margin-right 5px !important;'
                    : 'height: 30px; width: 30px; margin-right 5px !important;' &&
                      $vuetify.breakpoint.mdAndUp
                    ? 'height: 18px; width: 18px; margin-right 5px !important;'
                    : 'height: 12px; width: 12px; margin-right 5px !important;'
                "
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="user-shield"
                class="svg-inline--fa fa-user-shield fa-w-20"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512"
              >
                <g class="fa-group">
                  <path
                    class="fa-secondary"
                    fill="#fff"
                    d="M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM320.6 310.3C305.9 306.3 290.6 304 274.7 304H173.3C77.61 304 0 381.7 0 477.4C0 496.5 15.52 512 34.66 512H413.3c3.143 0 5.967-1.004 8.861-1.789C369.7 469.8 324.1 400.3 320.6 310.3z"
                  ></path>
                  <path
                    class="fa-primary"
                    fill="#F29E4D"
                    d="M622.3 271.1l-115.1-45.01c-4.125-1.629-12.62-3.754-22.25 0L369.8 271.1C359 275.2 352 285.1 352 295.1c0 111.6 68.75 188.8 132.9 213.9c9.625 3.75 18 1.625 22.25 0C558.4 489.9 640 420.5 640 295.1C640 285.1 633 275.2 622.3 271.1zM496 462.4V273.2l95.5 37.38C585.9 397.8 530.6 446 496 462.4z"
                  ></path>
                </g>
              </svg>
              <h5 style="color: black; margin-left: 5px">User Verified</h5>
            </v-row>

            <v-row
              align="center"
              justify="center"
              v-else
              class="mt-6 text-center text"
              style="align-items: center; margin-top: 0px !important"
            >
              <svg
                :style="
                  $vuetify.breakpoint.xsOnly
                    ? 'height: 10px; width: 10px; margin-right 5px !important;'
                    : '' && $vuetify.breakpoint.smAndDown
                    ? 'height: 30px; width: 30px; margin-right 5px !important;'
                    : 'height: 30px; width: 30px; margin-right 5px !important;' &&
                      $vuetify.breakpoint.mdAndUp
                    ? 'height: 18px; width: 18px; margin-right 5px !important;'
                    : 'height: 12px; width: 12px; margin-right 5px !important;'
                "
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="user-shield"
                class="svg-inline--fa fa-user-shield fa-w-20"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512"
              >
                <g class="fa-group">
                  <path
                    class="fa-secondary"
                    fill="#fff"
                    d="M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM320.6 310.3C305.9 306.3 290.6 304 274.7 304H173.3C77.61 304 0 381.7 0 477.4C0 496.5 15.52 512 34.66 512H413.3c3.143 0 5.967-1.004 8.861-1.789C369.7 469.8 324.1 400.3 320.6 310.3z"
                  ></path>
                  <path
                    class="fa-primary"
                    fill="#F29E4D"
                    d="M622.3 271.1l-115.1-45.01c-4.125-1.629-12.62-3.754-22.25 0L369.8 271.1C359 275.2 352 285.1 352 295.1c0 111.6 68.75 188.8 132.9 213.9c9.625 3.75 18 1.625 22.25 0C558.4 489.9 640 420.5 640 295.1C640 285.1 633 275.2 622.3 271.1zM496 462.4V273.2l95.5 37.38C585.9 397.8 530.6 446 496 462.4z"
                  ></path>
                </g>
              </svg>
              <h5 style="color: black; margin-left: 5px">User Not Verified</h5>
            </v-row>

            <v-row v-if="sub != '' && sub != undefined" class="mb-2 grid mt-5">
              <v-img
                style="position: relative"
                width="80px"
                height="80px"
                :src="require('@/assets/svgs/earth-2.svg')"
              />
            </v-row>
            <v-row
              class="mt-6 text-center"
              style="align-items: center; justify-content: center !important"
            >
              <div
                class="font-weight-bold h2"
                style="
                  justify-content: center;
                  color: black;
                  text-align: center;
                  justify: center;
                "
              >
                <svg
                  v-if="sub != '' && sub != undefined"
                  height="20px"
                  width="20px"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fad"
                  data-icon="location-dot"
                  class="svg-inline--fa fa-location-dot"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 384 512"
                >
                  <g class="fa-group">
                    <path
                      class="fa-secondary"
                      fill="#F8955B"
                      d="M192 0C85.97 0 0 85.97 0 192c0 77.41 26.97 99.03 172.3 309.7c9.531 13.77 29.91 13.77 39.44 0C357 291 384 269.4 384 192C384 85.97 298 0 192 0zM192 271.1c-44.13 0-80-35.88-80-80S147.9 111.1 192 111.1s80 35.88 80 80S236.1 271.1 192 271.1z"
                    ></path>
                    <path
                      class="fa-primary"
                      fill="black"
                      d="M240 191.1c0 26.51-21.49 48-48 48S144 218.5 144 191.1S165.5 143.1 192 143.1S240 165.5 240 191.1z"
                    ></path>
                  </g>
                </svg>
                {{ suburb }}
              </div>
            </v-row>
            <v-row
              align="center"
              justify="center"
              class="grid"
              style="
                align-items: center;
                color: black !important;
                margin-top: 36px !important;
              "
            >
              <p class="subtitle-1">
                <span
                  class="font-weight-bold"
                  :style="
                    $vuetify.breakpoint.smAndDown
                      ? 'height: 30px; width: 30px; font-size: 15px; '
                      : 'height: 30px; width: 30px; font-size: 20px; '
                  "
                >
                  Completed Bookings
                </span>
                <br />
                <br />
                <v-row
                  align="center"
                  justify="center"
                  class="grid"
                  style="align-items: center; margin-top: 0px !important"
                >
                  <v-img
                    style="height: 80px !important; width: 80px !important"
                    width="80px"
                    height="80px"
                    :src="require('@/assets/svgs/payment-4.svg')"
                  />
                </v-row>
                <br />
                <span class="f25">
                  {{ bookingsMade.length + bookingsReceived.length }}</span
                >
              </p>
            </v-row>

            <v-row
              align="center"
              justify="center"
              class="grid"
              style="
                align-items: center;
                color: black !important;
                margin-top: 36px !important;
                margin-bottom: 16px !important;
              "
            >
              <p class="subtitle-1">
                <span
                  class="font-weight-bold"
                  :style="
                    $vuetify.breakpoint.smAndDown
                      ? 'height: 30px; width: 30px; font-size: 15px; '
                      : 'height: 30px; width: 30px; font-size: 20px; '
                  "
                >
                  Active Listings
                </span>
                <br />

                <v-row
                  align="center"
                  justify="center"
                  class="grid"
                  style="align-items: center; margin-top: 0px !important"
                >
                  <v-img
                    style="height: 80px !important; width: 80px !important"
                    width="80px"
                    height="80px"
                    :src="require('@/assets/svgs/email-2.svg')"
                  />
                </v-row>
                <br />
                <span class="f25"> {{ items.length }}</span>
              </p>
            </v-row>

            <v-row
              class="grid"
              v-if="this.$store.state.user.id === this.$route.params.id"
            >
              <v-col cols="10">
                <v-btn
                  rounded
                  depressed
                  block
                  color="app lighten-3 white--text"
                  class="mr-3 font-weight-light"
                  to="/edit-profile"
                >
                  Edit Profile
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col cols="12" md="9">
          <v-card
            style="
              border-radius: 12px !important;
              margin: 5px;
              margin-bottom: 20px;
              margin-top: 20px;
              height: 350px;
              overflow-y: scroll !important;
              overflow-x: hidden !important;
            "
            outlined
            elevation="0"
          >
            <v-card-title class="grid">
              <v-row>
                <h3>Listed Items</h3>

                <template v-if="itemReviewAvg >= 1">
                  <h5 style="margin-left: 32px !important">
                    Average Rating: {{ itemReviewAvg }}
                  </h5>
                  <svg
                    aria-hidden="true"
                    height="20px"
                    width="20px"
                    focusable="false"
                    data-prefix="fad"
                    data-icon="star"
                    class="svg-inline--fa fa-star mx-1"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <g class="fa-group">
                      <path
                        class="fa-secondary"
                        fill="gold"
                        d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                      ></path>
                      <path class="fa-primary" fill="gold" d=""></path>
                    </g>
                  </svg>
                </template>
              </v-row>
            </v-card-title>
            <v-row v-if="items.length < 1" class="mb-2 grid mt-5">
              <p class="text-h4">No listings yet.</p>
              When {{ firstName }} lists an item(s) it will show up here.
              <v-img
                width="150px"
                height="150px"
                :src="require('@/assets/svgs/error-2.svg')"
              />
            </v-row>
            <v-row
              v-else
              justify="center"
              align="center"
              class="mx-auto"
              style="padding: 0px"
            >
              <v-col
                cols="12"
                md="4"
                v-for="item in items"
                v-if="item.status === 'available'"
                :key="item.id"
                style="margin: 0px"
              >
                <!-- {{ item.itemName }} -->
                <div>
                  <div>
                    <div
                      justify="center"
                      align="center"
                      class="ma-2 item"
                      @click="
                        $router.push(
                          '/items/' + item.itemName.replace(/\s+/g, '-')
                        )
                      "
                    >
                      <v-card
                        height="200px"
                        width="200px"
                        class="card"
                        style="border-radius: 12px"
                      >
                        <v-img
                          :src="item.images ? item.images[0] : ''"
                          height="200px"
                          width="200px"
                        />
                      </v-card>

                      <div class="clip text-body-1 black--text mb-0">
                        {{ item.itemName }}
                      </div>

                      <div>R{{ item.dailyFee }} p/day</div>

                      <div
                        :class="
                          item.availabilty == true ? 'green--text' : 'red--text'
                        "
                      >
                        {{
                          item.availabilty == true
                            ? 'Available '
                            : 'Not Available'
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>

          <!-- REVIEWS -->
          <template>
            <v-row>
              <v-btn
                v-bind="size"
                @click="changeReviewState('user')"
                :style="
                  reviewState === 'user'
                    ? 'border-bottom: 5px solid #B22AF0;'
                    : ''
                "
                text
                >From Lenders ({{ reviews.length }})</v-btn
              >
              <v-btn
                v-bind="size"
                @click="changeReviewState('item')"
                :style="
                  reviewState === 'item'
                    ? 'border-bottom: 5px solid #B22AF0;'
                    : ''
                "
                text
                >From Borrowers ({{ itemReviews.length }})</v-btn
              >
            </v-row>
            <!-- USER REVIEWS -->
            <template v-if="reviewState === 'user'">
              <v-row style="padding: 12px">
                <v-row v-if="reviews.length < 1" class="mb-2 grid mt-5 center">
                  <p class="text-h4 center">No reviews from lenders yet.</p>
                  <p class="center">
                    When someone reviews their lending experience with
                    {{ firstName }}, it will show up here.
                  </p>
                  <v-img
                    width="150px"
                    height="150px"
                    :src="require('@/assets/svgs/astronaut.svg')"
                  />
                </v-row>
                <v-card
                  v-if="reviews.length >= 1"
                  class="pa-3"
                  style="
                    border-radius: 13px;
                    padding: 16px !important;
                    width: 100%;
                    max-height: 600px !important;
                    overflow-y: scroll;
                  "
                  outlined
                  elevation="0"
                >
                  <v-row
                    class="font-weight-bold h2"
                    style="padding: 16px !important; justify-content: center"
                  >
                    <!-- <div

                    style="
                      color: black;
                  text-align: center;
                  width: 100%;
                    "
                  > -->
                    <h3>Reviews From Lenders</h3>
                    <template v-if="reviewAvg >= 1">
                      <h3 style="margin-left: 32px !important">
                        Average Rating: {{ reviewAvg }}
                      </h3>
                      <svg
                        aria-hidden="true"
                        height="20px"
                        width="20px"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="star"
                        class="svg-inline--fa fa-star mx-1"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="gold"
                            d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                          ></path>
                          <path class="fa-primary" fill="gold" d=""></path>
                        </g>
                      </svg>
                    </template>
                  </v-row>
                  <v-row
                    class="mx-5"
                    v-for="review in reviews"
                    :key="review.id"
                  >
                    <!-- <v-col cols="12" lg="2" md="12"> -->

                    <!-- </v-col> -->
                    <!-- <v-col  cols="12" lg="6" md="12"> -->
                    <div
                      class="font-weight-bold h2"
                      style="
                        color: black;
                        padding: 8px;
                        text-align: left;
                        justify: left;
                        width: 100%;
                        border-top: 1px solid #e0e0e0;
                        padding-top: 16px;
                      "
                    >
                      <v-row>
                        <v-col
                          style="padding: 4px"
                          cols="2"
                          lg="1"
                          xl="1"
                          md="2"
                        >
                          <v-avatar outline size="50">
                            <!-- <div > -->
                            <p class="hidden-sm-and-down hidden-md-and-up">
                              {{ review.reviewerAvatar }}
                            </p>
                            <v-img
                              v-if="review.reviewerAvatar != null"
                              :src="review.reviewerAvatar"
                            ></v-img>
                            <!-- </div> -->
                            <svg
                              v-else
                              viewBox="0 0 32 32"
                              xmlns="http://www.w3.org/2000/svg"
                              style="fill: currentcolor"
                              aria-hidden="true"
                              role="presentation"
                              focusable="false"
                            >
                              <path
                                d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                              ></path>
                            </svg>
                          </v-avatar>
                        </v-col>
                        <v-col
                          style="padding: 4px"
                          cols="7"
                          lg="8"
                          xl="8"
                          md="7"
                        >
                          <p
                            style="
                              float: center !important;
                              font-weight: normal;
                              color: black;
                              margin: 0px !important;
                              margin-left: 2px !important;
                            "
                          >
                            {{ review.lenderName }}
                          </p>

                          <v-rating
                            class="ma-4"
                            length="5"
                            readonly="{true}"
                            dense="{true}"
                            :value="review.rating"
                            color="yellow darken-2"
                            style="margin: 0px !important"
                          ></v-rating>
                        </v-col>
                        <v-col
                          style="padding: 4px"
                          cols="3"
                          lg="3"
                          xl="3"
                          md="3"
                        >
                          <p
                            style="
                              float: right;
                              font-weight: normal;
                              color: grey;
                            "
                          >
                            {{ review.date }}
                          </p>
                        </v-col>
                      </v-row>

                      <!-- <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ strappDate }}
                    </p>
                    <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ isVerified }}
                    </p> -->
                      <v-row>
                        <v-col
                          style="padding: 4px"
                          cols="2"
                          lg="1"
                          xl="1"
                          md="2"
                        ></v-col>
                        <v-col
                          style="padding: 4px"
                          cols="10"
                          lg="11"
                          xl="11"
                          md="10"
                        >
                          <h5
                            class="text"
                            style="
                              margin-left: 2px;
                              font-weight: normal !important;
                              color: black;
                            "
                          >
                            {{ review.review }}
                          </h5>
                        </v-col>
                      </v-row>
                    </div>
                  </v-row>

                  <!-- </v-col>
       <v-col cols="12" lg="4" md="12"> -->

                  <!-- </v-col> -->
                </v-card>
              </v-row>
            </template>

            <!-- ITEM REVIEWS -->
            <template v-if="reviewState === 'item'">
              <v-row style="padding: 12px">
                <v-row
                  v-if="itemReviews.length < 1"
                  class="mb-2 grid mt-5 center"
                >
                  <p class="text-h4 center">No reviews from borrowers yet.</p>
                  <p class="center">
                    When one of {{ firstName }}'s items get a review, it will
                    show up here.
                  </p>
                  <v-img
                    width="150px"
                    height="150px"
                    :src="require('@/assets/svgs/astronaut.svg')"
                  />
                </v-row>
                <v-card
                  v-if="itemReviews.length >= 1"
                  class="pa-3"
                  style="
                    border-radius: 13px;
                    padding: 16px !important;
                    width: 100%;
                    max-height: 600px !important;
                    overflow-y: scroll;
                  "
                  elevation="0"
                  outlined
                >
                  <v-row
                    class="font-weight-bold h2"
                    style="padding: 16px !important; justify-content: center"
                  >
                    <!-- <div

                    style="
                      color: black;
                  text-align: center;
                  width: 100%;
                    "
                  > -->
                    <h3>Reviews From Borrowers</h3>
                    <template v-if="itemReviewAvg >= 1">
                      <h3 style="margin-left: 32px !important">
                        Average Rating: {{ itemReviewAvg }}
                      </h3>
                      <svg
                        aria-hidden="true"
                        height="20px"
                        width="20px"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="star"
                        class="svg-inline--fa fa-star mx-1"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <g class="fa-group">
                          <path
                            class="fa-secondary"
                            fill="gold"
                            d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                          ></path>
                          <path class="fa-primary" fill="gold" d=""></path>
                        </g>
                      </svg>
                    </template>
                  </v-row>
                  <v-row
                    class="mx-5"
                    v-for="review in itemReviews"
                    :key="review.id"
                  >
                    <!-- <v-col cols="12" lg="2" md="12"> -->

                    <!-- </v-col> -->
                    <!-- <v-col  cols="12" lg="6" md="12"> -->
                    <div
                      class="font-weight-bold h2"
                      style="
                        color: black;
                        padding: 8px;
                        text-align: left;
                        justify: left;
                        width: 100%;
                        border-top: 1px solid #e0e0e0;
                        padding-top: 16px;
                      "
                    >
                      <v-row>
                        <v-col
                          style="padding: 4px"
                          cols="2"
                          lg="1"
                          xl="1"
                          md="2"
                        >
                          <v-avatar outline size="50">
                            <!-- <div > -->
                            <p class="hidden-sm-and-down hidden-md-and-up">
                              {{ review.reviewerAvatar }}
                            </p>
                            <v-img
                              v-if="review.reviewerAvatar != null"
                              :src="review.reviewerAvatar"
                            ></v-img>
                            <!-- </div> -->
                            <svg
                              v-else
                              viewBox="0 0 32 32"
                              xmlns="http://www.w3.org/2000/svg"
                              style="fill: currentcolor"
                              aria-hidden="true"
                              role="presentation"
                              focusable="false"
                            >
                              <path
                                d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                              ></path>
                            </svg>
                          </v-avatar>
                        </v-col>
                        <v-col
                          style="padding: 4px"
                          cols="7"
                          lg="8"
                          xl="8"
                          md="7"
                        >
                          <p
                            style="
                              float: center !important;
                              font-weight: normal;
                              color: black;
                              margin: 0px !important;
                              margin-left: 2px !important;
                            "
                          >
                            {{ review.borrowerName }} - {{ review.itemName }}
                          </p>

                          <v-rating
                            class="ma-4"
                            length="5"
                            readonly="{true}"
                            dense="{true}"
                            :value="review.rating"
                            color="yellow darken-2"
                            style="margin: 0px !important"
                          ></v-rating>
                        </v-col>
                        <v-col
                          style="padding: 4px"
                          cols="3"
                          lg="3"
                          xl="3"
                          md="3"
                        >
                          <p
                            style="
                              float: right;
                              font-weight: normal;
                              color: grey;
                            "
                          >
                            {{ review.date }}
                          </p>
                        </v-col>
                      </v-row>

                      <!-- <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ strappDate }}
                    </p>
                    <p class="hidden-sm-and-down hidden-md-and-up">
                      {{ isVerified }}
                    </p> -->
                      <v-row>
                        <v-col
                          style="padding: 4px"
                          cols="2"
                          lg="1"
                          xl="1"
                          md="2"
                        ></v-col>
                        <v-col
                          style="padding: 4px"
                          cols="10"
                          lg="11"
                          xl="11"
                          md="10"
                        >
                          <h5
                            class="text"
                            style="
                              margin-left: 2px;
                              font-weight: normal !important;
                              color: black;
                            "
                          >
                            {{ review.review }}
                          </h5>
                        </v-col>
                      </v-row>
                    </div>
                  </v-row>

                  <!-- </v-col>
       <v-col cols="12" lg="4" md="12"> -->

                  <!-- </v-col> -->
                </v-card>
              </v-row>
            </template>
          </template>
          <!-- <v-row style="padding: 12px">
            <v-row v-if="reviews.length < 1" class="mb-2 grid mt-5">
              <p class="text-h4">No Reviews yet.</p>
              When {{ firstName }} get's a review, it will show up here.
              <v-img
                width="150px"
                height="150px"
                :src="require('@/assets/svgs/astronaut.svg')"
              />
            </v-row>
            <v-card
              v-if="reviews.length >= 1"
              class="pa-3"
              style="
                border-radius: 13px;
                padding: 16px !important;
                width: 100%;
                max-height: 338px !important;
                overflow-y: scroll;
              "
              elevation="4"
            >
              <v-row
                class="font-weight-bold h2"
                style="padding-top: 16px !important; justify-content: center"
              >

                <h3>Reviews: {{ reviews.length }}</h3>
                <template v-if="reviewAvg >= 1">
                  <h5 style="margin-left: 32px !important">
                    Average Rating: {{ reviewAvg }}
                  </h5>
                  <svg
                    aria-hidden="true"
                    height="20px"
                    width="20px"
                    focusable="false"
                    data-prefix="fad"
                    data-icon="star"
                    class="svg-inline--fa fa-star mx-1"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <g class="fa-group">
                      <path
                        class="fa-secondary"
                        fill="gold"
                        d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z"
                      ></path>
                      <path class="fa-primary" fill="gold" d=""></path>
                    </g>
                  </svg>
                </template>
              </v-row>
              <v-row v-for="review in reviews" :key="review.id">

                <div
                  class="font-weight-bold h2"
                  style="
                    color: black;
                    padding: 8px;
                    text-align: left;
                    justify: left;
                    width: 100%;
                    border-top: 1px solid #e0e0e0;
                    padding-top: 16px;
                  "
                >
                  <v-row>
                    <v-col style="padding: 4px" cols="2" lg="1" xl="1" md="2">
                      <v-avatar outline size="50">

                        <p class="hidden-sm-and-down hidden-md-and-up">
                          {{ review.reviewerAvatar }}
                        </p>
                        <v-img
                          v-if="review.reviewerAvatar != null"
                          :src="review.reviewerAvatar"
                        ></v-img>

                        <svg
                          v-else
                          viewBox="0 0 32 32"
                          xmlns="http://www.w3.org/2000/svg"
                          style="fill: currentcolor"
                          aria-hidden="true"
                          role="presentation"
                          focusable="false"
                        >
                          <path
                            d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                          ></path>
                        </svg>
                      </v-avatar>
                    </v-col>
                    <v-col style="padding: 4px" cols="7" lg="8" xl="8" md="7">
                      <p
                        style="
                          float: center !important;
                          font-weight: normal;
                          color: black;
                          margin: 0px !important;
                          margin-left: 2px !important;
                        "
                      >
                        {{ review.lenderName }}
                      </p>

                      <v-rating
                        class="ma-4"
                        length="5"
                        readonly="{true}"
                        dense="{true}"
                        :value="review.rating"
                        color="yellow darken-2"
                        style="margin: 0px !important"
                      ></v-rating>
                    </v-col>
                    <v-col style="padding: 4px" cols="3" lg="3" xl="3" md="3">
                      <p style="float: right; font-weight: normal; color: grey">
                        {{ review.date }}
                      </p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      style="padding: 4px"
                      cols="2"
                      lg="1"
                      xl="1"
                      md="2"
                    ></v-col>
                    <v-col
                      style="padding: 4px"
                      cols="10"
                      lg="11"
                      xl="11"
                      md="10"
                    >
                      <h5
                        class="text"
                        style="
                          margin-left: 2px;
                          font-weight: normal !important;
                          color: black;
                        "
                      >
                        {{ review.review }}
                      </h5>
                    </v-col>
                  </v-row>
                </div>
              </v-row>

            </v-card>
          </v-row> -->
        </v-col>
      </v-row>
    </v-card>
    <div></div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import firebase from 'firebase/compat/app';
import Profile from '../components/Profile/Profile.vue';
// import Verify from "../components/Profile/Verify.vue";
import _ from 'lodash';
import DeclineBookingDialog from '../components/declineBookingDialog.vue';
import { getDocs, collection, query, getFirestore } from 'firebase/firestore';

export default {
  data() {
    return {
      reviewState: 'user',
      uid: '',
      avatarPic: '',
      hasAvatar: true,
      fName: '',
      startDate: null,
      sub: '',
      verified: false,
      bookings: [],
      // user: {
      //   firstName: 'John',
      //   lastName: 'Doe'
      // }
    };
  },
  components: {
    Loader: () => import('@/components/Loader.vue'),
  },

  methods: {
    changeReviewState: function (newState) {
      this.reviewState = newState;
    },
  },
  async beforeCreate() {
    console.log('beforeMount bookings', this.$store.getters.loadedBookings);
    // console.log('beforeMount id', this.$store.getters.user.id);

    // this.$store.getters.loadedBookings;

    if (this.$store.getters.loadedBookings !== undefined) {
      this.bookings = this.$store.getters.loadedBookings;
    }
    if (this.bookings == undefined) {
      this.$store.commit('setLoading', true);

      const db = getFirestore();

      const q = query(collection(db, 'bookings'));

      const lendingQuerySnapshot = await getDocs(q);

      const bookings = [];

      lendingQuerySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        var b = doc.data();
        b.id = doc.id;
        bookings.push(b);
      });

      console.log('bookings', bookings);

      this.bookings = bookings;

      this.$store.commit('setLoadedBookings', bookings);
      this.$store.commit('setLoading', false);
    }
  },

  computed: {
    size() {
      const size = { xs: 'x-small', sm: 'medium', lg: 'large', xl: 'large' }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    // ...Vuex.mapState(['loadedUser', 'status']),
    loading() {
      return this.$store.getters.loading;
    },

    reviews() {
      console.log('all reviews: ', this.$store.getters.loadedReviews);
      return this.$store.getters.loadedReviews.filter(
        (review) =>
          review.borrowerID === this.uid && review.reviewType === 'user'
      );
    },

    reviewAvg() {
      let sum = 0;
      let count = 0;
      this.reviews.forEach((review) => {
        sum += review.rating;
        count++;
      });
      if (sum === 0) {
        return 0;
      } else {
        return Math.round((sum / count) * 100) / 100;
      }
    },

    itemReviews() {
      console.log('all reviews: ', this.$store.getters.loadedReviews);
      return this.$store.getters.loadedReviews.filter(
        (review) => review.lenderID === this.uid && review.reviewType === 'item'
      );
    },

    itemReviewAvg() {
      let sum1 = 0;
      let count1 = 0;
      this.items.forEach((item) => {
        if (item.rating != undefined) {
          sum1 += item.rating * item.rating_count;
          count1 = count1 + Number(item.rating_count);
        }
      });
      console.log(sum1, count1);
      if (sum1 === 0) {
        return 0;
      } else {
        return Math.round((sum1 / count1) * 100) / 100;
      }
    },

    bookingsMade() {
      let uri = window.location.href.split('/');

      this.uid = uri[uri.length - 1];
      // do

      // return _.filter(this.$store.getters.loadedBookings, {
      //   (borrowerID =  this.uid),
      // }).length;

      return this.bookings.filter((booking) => {
        return (
          booking.borrowerID === this.uid &&
          (booking.status === 'returned' ||
            booking.status === 'returnedB' ||
            booking.status === 'returnedL' ||
            booking.status === 'complete' ||
            booking.status === 'pending-deposit')
        );
      });
    },

    bookingsReceived() {
      let uri = window.location.href.split('/');

      this.uid = uri[uri.length - 1];
      // do

      // return _.filter(this.$store.getters.loadedBookings, {
      //   (borrowerID =  this.uid),
      // }).length;

      return this.bookings.filter((booking) => {
        return (
          booking.lenderID === this.uid &&
          (booking.status === 'returned' ||
            booking.status === 'returnedB' ||
            booking.status === 'returnedL' ||
            booking.status === 'complete' ||
            booking.status === 'pending-deposit')
        );
      });
    },

    user() {
      let uri = window.location.href.split('/');

      this.uid = uri[uri.length - 1];

      firebase
        .firestore()
        .collection('users')
        .doc(this.uid)
        .get()
        .then((querySnapshot) => {
          // this.avatar =  querySnapshot.data().avatar

          return querySnapshot.data();
        });
    },

    async avatar() {
      let uri = window.location.href.split('/');

      this.uid = uri[uri.length - 1];
      this.hasAvatar = false;
      await firebase
        .firestore()
        .collection('users')
        .doc(this.uid)
        .get()
        .then((querySnapshot) => {
          // this.avatar =  querySnapshot.data().avatar

          return (this.avatarPic = querySnapshot.data().avatar);
        });
      console.log('avater', this.avatarPic);

      if (
        this.avatarPic != undefined &&
        this.avatarPic != '' &&
        this.avatarPic != null
      ) {
        console.log('has avater');
        this.hasAvatar = true;
      }
      return this.avatarPic;
    },

    firstName() {
      let uri = window.location.href.split('/');
      console.log(uri);
      this.uid = uri[uri.length - 1];

      firebase
        .firestore()
        .collection('users')
        .doc(this.uid)
        .get()
        .then((querySnapshot) => {
          // this.avatar =  querySnapshot.data().avatar

          return (this.fName = querySnapshot.data().firstName);
        });
      return this.fName;
    },

    isVerified() {
      let uri = window.location.href.split('/');
      console.log(uri);
      this.uid = uri[uri.length - 1];

      firebase
        .firestore()
        .collection('users')
        .doc(this.uid)
        .get()
        .then((querySnapshot) => {
          // this.avatar =  querySnapshot.data().avatar

          return (this.verified = querySnapshot.data().verified);
        });
      console.log('verified: ', this.verified);
      return this.verified;
    },

    suburb() {
      let uri = window.location.href.split('/');
      console.log(uri);
      this.uid = uri[uri.length - 1];

      firebase
        .firestore()
        .collection('users')
        .doc(this.uid)
        .get()
        .then((querySnapshot) => {
          // this.avatar =  querySnapshot.data().avatar
          console.log('suburb- ', querySnapshot.data());
          return (this.sub = querySnapshot.data().suburb);
        });
      console.log('suburb- s', this.sub);
      return this.sub;
    },

    items() {
      //  console.log(this.$store.state.loadedUser.id)
      return this.$store.getters.loadedItems.filter((item) => {
        return item.userID === this.uid && item.availabilty === true;
      });
    },

    strappDate() {
      let uri = window.location.href.split('/');
      console.log(uri);
      this.uid = uri[uri.length - 1];
      firebase
        .firestore()
        .collection('users')
        .doc(this.uid)
        .get()
        .then((querySnapshot) => {
          //           this.avatar =  querySnapshot.data().avatar
          // console.log(this.avatar)
          if (querySnapshot.data().createdAt) {
            let d = querySnapshot.data().createdAt.seconds;
            console.log(d);
            var date = new Date(d * 1000).toString();
            date = date.substring(4, 15);
            console.log('dates:', date);

            return (this.startDate = date);
          } else {
            console.log('datesss:');
            return (this.startDate = null);
          }
        });
      console.log('start daTE:', this.startDate);
      return this.startDate;
    },
  },

  created() {
    this.$store.dispatch('loadBookings');
    try {
      const id = this.$route.params.id;
      if (this.$route.params.id == undefined) throw Error('user doesnt exist');
      // this.$store.dispatch('loadUser', id);
    } catch (e) {
      console.log(e);
    }
  },
};
</script>

<style scoped>
.center {
  display: grid;
  place-items: center;
  justify-content: center;
  text-align: center;
}
</style>
